export enum AGORA_STATE {
  EMPTY,
  CLIENT_CREATED,
  CLIENT_JOINED,
  STREAM_CREATING,
  STREAM_DISABLED,
  STREAM_ENABLED,
}
